import React from 'react';
import ReactDOM from 'react-dom';
import ImageGallery from 'react-image-gallery';
import Service from './PhotoService';
import '../../../node_modules/react-image-gallery/styles/scss/image-gallery.scss';


export default class PhotoBankGallery extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: []
        };
        this.renderItem = this.renderItem.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        return (
            <div>                
                <div className="banner-wrapper">
                    <ImageGallery
                        items={this.state.items}
                        renderItem={this.renderItem}
                        showFullscreenButton={false}
                        showPlayButton={false}
                        autoPlay={true}
                        slideInterval={7000}
                        slideDuration={750}
                        showThumbnails={false}
                        showNav={true}
                    />
                </div>
            </div>
        );
    }

    renderItem(item) {
        const divStyle = {
            backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) ), url(' + item.image.websitePath + ')',
            height: '600px'
        };

        return (
            <div className='banner-image-wrapper' style={divStyle}>

            </div>
        );

    }

    loadData() {
        Service.getPhotoItems()
            .then(res => {
                this.setState({
                    items: res
                });
            });
    }
}

var root = document.getElementById('js-photo-plugin');

if (root !== null && root !== undefined) {
    ReactDOM.render(<PhotoBankGallery />, root);
}


// WEBPACK FOOTER //
// ./Src/Components/PhotoGallery/PhotoGallery.jsx